import { Component } from '@angular/core';

import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './confirm.component.html',
    standalone: false
})
export class ConfirmModalComponent extends BaseModalDirective {}
